<template>
  <!-- <div class="app-container"> -->
  <div class="">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="88px">
      <!-- <el-form-item label="主键" prop="pid">
        <el-input
          v-model="queryParams.pid"
          placeholder="请输入主键"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="租户" prop="tenantId">
        <el-input
          v-model="queryParams.tenantId"
          placeholder="请输入租户"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item label="合同名称" prop="contractName">
        <el-input
          v-model="queryParams.contractName"
          placeholder="请输入合同名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="甲方名称" prop="partyAName">
        <el-input
          v-model="queryParams.partyAName"
          placeholder="请输入甲方名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="项目所在地" prop="projectLocation">
        <el-input
          v-model="queryParams.projectLocation"
          placeholder="请输入项目所在地"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <br/>
      <el-form-item label="合同金额" prop="contractAmount">
        <el-input
          v-model="queryParams.contractAmount"
          placeholder="请输入合同金额"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="签订日期" prop="dateSigning">
        <el-date-picker clearable
          v-model="queryParams.dateSigning"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择签订日期">
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="附件" prop="appIds">
        <el-input
          v-model="queryParams.appIds"
          placeholder="请输入附件"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="版本" prop="version">
        <el-input
          v-model="queryParams.version"
          placeholder="请输入版本"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['creditlibrary:historicalcases:add']"
        >新增</el-button>
      </el-col>
      <!-- <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['creditlibrary:historicalcases:edit']"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['creditlibrary:historicalcases:remove']"
        >删除</el-button>
      </el-col> -->
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['creditlibrary:historicalcases:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="historicalcasesList" @selection-change="handleSelectionChange"   max-height="650">
      <el-table-column type="selection" width="40" align="center" />
      <!-- <el-table-column label="主键" align="center" prop="pid" /> -->
      <!-- <el-table-column label="租户" align="center" prop="tenantId" /> -->
      <el-table-column label="合同名称" align="center" prop="contractName" />
      <el-table-column label="甲方名称" align="center" prop="partyAName" />
      <el-table-column label="项目所在地" align="center" prop="projectLocation" />
      <el-table-column label="合同金额" align="center" prop="contractAmount" />
      <el-table-column label="签订日期" align="center" prop="dateSigning" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.dateSigning, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="附件" align="center" prop="appIds" />
      <el-table-column label="版本" align="center" prop="version" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['creditlibrary:historicalcases:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['creditlibrary:historicalcases:remove']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改历史案例对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <!-- <el-form-item label="主键" prop="pid">
          <el-input v-model="form.pid" placeholder="请输入主键" />
        </el-form-item>
        <el-form-item label="租户" prop="tenantId">
          <el-input v-model="form.tenantId" placeholder="请输入租户" />
        </el-form-item> -->
        <el-form-item label="合同名称" prop="contractName">
          <el-input v-model="form.contractName" placeholder="请输入合同名称" />
        </el-form-item>
        <el-form-item label="甲方名称" prop="partyAName">
          <el-input v-model="form.partyAName" placeholder="请输入甲方名称" />
        </el-form-item>
        <el-form-item label="项目所在地" prop="projectLocation">
          <el-input v-model="form.projectLocation" placeholder="请输入项目所在地" />
        </el-form-item>
        
        <el-form-item label="合同金额" prop="contractAmount">
          <el-input v-model="form.contractAmount" placeholder="请输入合同金额" />
        </el-form-item>
        <el-form-item label="签订日期" prop="dateSigning">
          <el-date-picker clearable
            v-model="form.dateSigning"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择签订日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="附件" prop="appIds">
          <el-input v-model="form.appIds" placeholder="请输入附件" />
        </el-form-item>
        <!-- <el-form-item label="版本" prop="version">
          <el-input v-model="form.version" placeholder="请输入版本" />
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listHistoricalcases, getHistoricalcases, delHistoricalcases, addHistoricalcases, updateHistoricalcases } from "@/api/creditlibrary/historicalcases";

export default {
  name: "Historicalcases",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 历史案例表格数据
      historicalcasesList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pid: null,
        tenantId: null,
        contractName: null,
        partyAName: null,
        projectLocation: null,
        contractAmount: null,
        dateSigning: null,
        appIds: null,
        version: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询历史案例列表 */
    getList() {
      this.loading = true;
      listHistoricalcases(this.queryParams).then(response => {
        this.historicalcasesList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        pid: null,
        tenantId: null,
        contractName: null,
        partyAName: null,
        projectLocation: null,
        contractAmount: null,
        dateSigning: null,
        appIds: null,
        version: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.pid)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加历史案例";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const pid = row.pid || this.ids
      getHistoricalcases(pid).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改历史案例";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.pid != null) {
            updateHistoricalcases(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addHistoricalcases(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const pids = row.pid || this.ids;
      this.$modal.confirm('是否确认删除历史案例编号为"' + pids + '"的数据项？').then(function() {
        return delHistoricalcases(pids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('creditlibrary/historicalcases/export', {
        ...this.queryParams
      }, `historicalcases_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
